import { render, staticRenderFns } from "./LeftPerfil.vue?vue&type=template&id=1c0e6f80&scoped=true"
import script from "./LeftPerfil.vue?vue&type=script&lang=js"
export * from "./LeftPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0e6f80",
  null
  
)

export default component.exports